import $ from "jquery";
import "jquery-validation";
import Swal from 'sweetalert2';
import { showCaptchaDialog } from "framework/index";
const $frmMain = $(document.forms["frmMain"]);

function lockFormLogin() {
    $("fieldset", $frmMain).prop("disabled", true);
}
function unlockFormLogin() {
    $("fieldset", $frmMain).prop("disabled", false);
}

function setFormLogining() {
    $("button[type=submit]", $frmMain).children(".btn-icon").addClass("!hidden");
    $("button[type=submit]", $frmMain).children(".btn-loading").removeClass("!hidden");
    $("button[type=submit]", $frmMain).children("span").text("正在登录");
}
function resetFormLogining() {
    const loginMode = $("[name='Input.LoginMode']:checked", $frmMain).val();
    $("button[type=submit]", $frmMain).children(".btn-loading").addClass("!hidden");
    if (loginMode === "code") {
        $("button[type=submit]", $frmMain).children("span").html('登录<small class="mx-1">/</small>注册');
    } else {
        $("button[type=submit]", $frmMain).children(".btn-icon").removeClass("!hidden");
        $("button[type=submit]", $frmMain).children("span").text("登 录");
    }
}

$.validator.addMethod("userNameFormat", function (value, element, parms) {
    if (!value) return true;
    return /^1[3-9]\d{9}$/.test(value) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}, "手机号/邮箱格式错误");
$frmMain.validate({
    errorClass: "is-invalid",
    errorElement: "span",
    ignore: ":hidden,.ignore",// 增加忽略检测的元素
    validClass: "is-valid",
    errorPlacement(error, inputElement) {
        error.addClass("invalid-message");
        error.insertAfter(inputElement);
    },
    rules: {
        "Input.Username": {
            required: true,
            userNameFormat: true,
        },
        "Input.Password": {
            required: true
        }
    },
    messages: {
        "Input.Username": {
            required: "请输入手机号/邮箱",
            customRule: function () {
                debugger;
            }
        },
        "Input.Password": {
            required: "请输入验证码"
        }
    }
});

$frmMain.on("submit", async evt => {
    debugger;
    evt.preventDefault();
    lockFormLogin();
    if (!$("[name='Input.Agree']", $frmMain).is(":checked")) {
        const dialogResult = await Swal.fire({
            scrollbarPadding: false,
            html: `<span class="align-middle">我已阅读并同意</span>
<a class="align-middle text-blue-600 hover:text-blue-700" href="#">服务协议</a>
<span class="align-middle">和</span>
<a class="align-middle text-blue-600 hover:text-blue-700" href="#">隐私政策</a>`,
            icon: "info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "同意",
            cancelButtonText: "不同意"
        });
        // 判断是否操作的取消
        if (dialogResult.dismiss) {
            unlockFormLogin();
            return;
        }
        // 选择同意后，设置选中状态
        $("[name='Input.Agree']", $frmMain).prop("checked", true);
    }

    try {
        // 判断登录模式是否密码登录
        if ($("[name='Input.LoginMode']", $frmMain).val() === "password") {
            const captchaToken = await showCaptchaDialog("Login");

            $("[name='Input.CaptchaToken']", $frmMain).val(captchaToken);
        }
        setFormLogining();

        const data = await $.ajax("?handler=LoginAjax", {
            type: "POST",
            data: {
                "Input.LoginMode": $("[name='Input.LoginMode']", $frmMain).val(),
                "Input.Username": $("[name='Input.Username']", $frmMain).val(),
                "Input.Password": $("[name='Input.Password']", $frmMain).val(),
                "Input.Agree": $("[name='Input.Agree']", $frmMain).val(),
                "Input.CaptchaToken": $("[name='Input.CaptchaToken']", $frmMain).val(),
                "__RequestVerificationToken": $("[name='__RequestVerificationToken']").val(),
            },
            statusCode: {
                400: function (res) {
                    Swal.fire({
                        scrollbarPadding: false,
                        title: "登录失败",
                        text: res.responseText,
                        icon: "warning",
                        confirmButtonText: "好的👌"
                    });
                    unlockFormLogin();
                }
            }
        });
        if (data.SignResult === "Succeeded") {
            // 登录成功
            location.replace(data.Redirect);
        } else if (data.SignResult === "RequiresTwoFactor") {
            // 需要二次验证
            location.replace(data.Redirect);
        } else if (data.SignResult === "IsLockedOut") {
            // 账号被锁定
            Swal.fire({
                scrollbarPadding: false,
                title: "登录失败",
                text: `检测到您的账号进行了过多的尝试，当前账号已锁定。请${Math.ceil(data.LockoutTime / 60)}分钟后再试。`,
                icon: "warning",
                confirmButtonText: "好的👌"
            });
        } else if (data.SignResult === "IsNotAllowed") {
            // 用户未激活使用
            location.replace(data.Redirect);
        } else if (data.SignResult === "CodeFailed") {
            Swal.fire({
                scrollbarPadding: false,
                title: "登录失败",
                text: `验证码错误或已失效`,
                icon: "warning",
                confirmButtonText: "好的👌"
            });
        } else {
            //
            Swal.fire({
                scrollbarPadding: false,
                title: "登录失败",
                text: `用户名不正确或密码错误`,
                icon: "warning",
                confirmButtonText: "好的👌"
            });
        }
    } catch {

    } finally {
        unlockFormLogin();
        resetFormLogining();
    }
});


$("[name='Input.LoginMode']", $frmMain).on("change", function () {
    const loginMode = $(this).val();
    if (loginMode === "code") {
        // 验证码登录
        $(".input-captcha-icon", $frmMain).removeClass("!hidden"); // 显示图形验证码图标
        $(".input-password-icon", $frmMain).addClass("!hidden");// 隐藏密码图标
        $(".code-tips", $frmMain).removeClass("hidden");// 显示图形验证码提示
        $(".password-tips", $frmMain).addClass("hidden");// 隐藏密码提示
        $(".register-link", $frmMain).addClass("invisible");// 隐藏注册入口

        $("button[type=submit]", $frmMain).children(".btn-icon").addClass("!hidden"); // 隐藏登录图标
        $("button[type=submit]", $frmMain).children("span").html('登录<small class="mx-1">/</small>注册');
        $("button[type=submit]", $frmMain).children(".bi-box-arrow-in-right").addClass("!hidden");


        $("[name='Input.Password']", $frmMain).prop({
            type: "text",
            autocomplete: "off-CaptchaCode",
            placeholder: "验证码",
            value: "",
        });


        const validator = $frmMain.validate();
        validator.settings.messages["Input.Password"].required = "请输入验证码";
        validator.resetForm();// 重置验证状态

        $("[name='Input.CaptchaToken']", $frmMain).show();// 显示获取验证码按钮
    } else {
        // 密码登录
        $(".input-captcha-icon", $frmMain).addClass("!hidden"); // 隐藏图形验证码图标
        $(".input-password-icon", $frmMain).removeClass("!hidden");// 显示密码图标
        $(".code-tips", $frmMain).addClass("hidden");// 隐藏图形验证码提示
        $(".password-tips", $frmMain).removeClass("hidden");// 显示密码提示
        $(".register-link", $frmMain).removeClass("invisible");// 显示注册入口

        $("button[type=submit]", $frmMain).children(".btn-icon").removeClass("!hidden"); // 显示登录图标
        $("button[type=submit]", $frmMain).children("span").html('登 录');
        $("button[type=submit]", $frmMain).children(".bi-box-arrow-in-right").removeClass("!hidden");

        $("[name='Input.Password']", $frmMain).prop({
            type: "password",
            autocomplete: "off-password",
            placeholder: "密码",
            value: "",
        });

        const validator = $frmMain.validate();
        validator.settings.messages["Input.Password"].required = "请输入密码";
        validator.resetForm();// 重置验证状态

        $("[name='Input.CaptchaToken']", $frmMain).hide(); //隐藏获取验证码按钮
    }
});

$("[command=sendCaptchaCode]", $frmMain).prop("disabled", !Boolean($("[name='Input.Username']", $frmMain).val()));
// 检测用户名输入框中是否存在值，若存在值，则允许进行获取验证码的操作
$("[name='Input.Username']", $frmMain).on("input", () => {
    const value = $("[name='Input.Username']", $frmMain).val();
    $("[command=sendCaptchaCode]", $frmMain).prop("disabled", !Boolean(value));
})


// 从本地提取验证码过期时间
const captchaCodeExpire = localStorage.getItem("captchaCodeExpire");
let disabledTimer;
// 判断是否存在内容
if (captchaCodeExpire) {
    // 计算还需要禁用的时长
    const disabledTimes = Number(captchaCodeExpire) - Date.now();
    // 如果禁用时间大于0，则还原倒计时状态
    if (disabledTimes > 0) {
        $("[name='Input.CaptchaToken']", $frmMain).prop("disabled", true);
        tryStartCaptchaTimer(Math.ceil(disabledTimes / 1000)); // 时间向上取整
    } else {
        // 清除过期时间，避免后续刷新重新跑内部逻辑
        localStorage.removeItem("captchaCodeExpire");
    }
}
function tryStartCaptchaTimer(disabledTimes = 60) {
    if (disabledTimes <= 0) {
        return;
    }
    clearTimeout(disabledTimer);
    const oldInnerHtml = $("[name='Input.CaptchaToken']", $frmMain).html();
    refreshButtonContent();
    disabledTimer = setInterval(startTimer, 1000);
    function startTimer() {
        // 每次执行减少一秒
        disabledTimes--;
        if (disabledTimes == 0) {
            // 恢复按钮禁用状态
            $("[name='Input.CaptchaToken']", $frmMain).prop("disabled", false);
            clearTimeout(disabledTimer);
            $("[name='Input.CaptchaToken']", $frmMain).html(oldInnerHtml);
            localStorage.removeItem("captchaCodeExpire");
            return;
        }
        refreshButtonContent();
    };

    function refreshButtonContent() {
        $("[name='Input.CaptchaToken']", $frmMain).html(`<b class='text-red-500'>${disabledTimes}</b>秒后可重发`);
    }
}

$("[command=sendCaptchaCode]", $frmMain).on("click", async evt => {
    $(evt.currentTarget).prop("disabled", true);
    try {
        // 显示图形验证码窗口
        const token = await showCaptchaDialog("SendCode");
        // 使用图形验证码窗口获得的token进行发送验证码
        const { data } = await $.ajax({
            url: "./Captcha/?handler=SendCode",
            method: "POST",
            dataType: "json",
            //contentType: "application/json",
            data: {
                "__RequestVerificationToken": $(":input[name='__RequestVerificationToken']").val(),
                "Input.CaptchaToken": token,
                "Input.Target": $("[name='Input.Username']", $frmMain).val(),
                "Input.Purpose": "Login"
            },
            statusCode: {
                400: function (res) {
                    Swal.fire({
                        scrollbarPadding: false,
                        text: res.responseText,
                        icon: "warning",
                        confirmButtonText: "好的👌"
                    });
                    //$((evt.originalEvent as any).submitter).removeAttr("disabled");
                }
            }
        })

        $("[name='Input.CaptchaToken']", $frmMain).val(data.token);

        Swal.fire({
            scrollbarPadding: false,
            confirmButtonText: "好的👌",
            "title": "验证码发送成功",
            html: "<b class='text-red-500'>3分钟有效，请不要将您的验证码告诉任何人！</b>",
            icon: "success"
        });

        const times = 60;
        // 验证码过期时间
        localStorage.setItem("captchaCodeExpire", String(Date.now() + times * 1000));
        tryStartCaptchaTimer(times);
    } catch (err) {
        $(evt.currentTarget).prop("disabled", false);

    }
})